import { render, staticRenderFns } from "./BSelectStepper.vue?vue&type=template&id=5053762c&"
import script from "./BSelectStepper.vue?vue&type=script&lang=js&"
export * from "./BSelectStepper.vue?vue&type=script&lang=js&"
import style0 from "./BSelectStepper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports